export function abrirPlanillaPopup(idPlanilla) {
  window.open(
    `/planilla-consulta/${idPlanilla}`,
    `planilla_${idPlanilla}`,
    "width=1100,height=750,scrollbars=yes,resizable=yes"
  );
}